import React from 'react';
import styles from './Overview.module.css';

const Overview = ({ data }) => {
  return (
    <section id="overview" className={`${styles.overview} section`}>
      <div className="container">
        <h2 className="section-title fade-in">{data.title}</h2>
        <div className={styles.overviewGrid}>
          <div className={`${styles.overviewText} fade-in`}>
            {data.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
          <div className="fade-in">
            <div className={styles.overviewStats}>
              {data.stats.map((stat, index) => (
                <div key={index} className={styles.statItem}>
                  <span className={styles.statNumber}>{stat.number}</span>
                  <div className={styles.statLabel}>{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Overview;
